import { Grid } from "@mui/material";
import { RestrictedMakerRealm } from "features/access-management";

import { AccessGrantsCard } from "features/access-grants";
import { ApiKeysCard } from "features/public-api";
import { SolutionOverview } from "features/solution";
import {
  AdminConsoleCard,
  RestrictedTenantRealm,
  TenantPermission
} from "features/tenant";

import { WorkspacesCard } from "features/workspace";

export default function LandingPage() {
  return (
    <Grid container spacing={4}>
      <RestrictedMakerRealm silent>
        <Grid item xs={12}>
          <SolutionOverview />
        </Grid>
      </RestrictedMakerRealm>
      <Grid container spacing={4} padding={4}>
        <RestrictedMakerRealm silent>
          <RestrictedTenantRealm
            requiredPermissions={[TenantPermission.ReadApiKeys]}
            silent={true}
          >
            <Grid item>
              <ApiKeysCard />
            </Grid>
          </RestrictedTenantRealm>
          <RestrictedTenantRealm
            requiredPermissions={[TenantPermission.ManageAccessGrants]}
            silent={true}
          >
            <Grid item>
              <AccessGrantsCard />
            </Grid>
          </RestrictedTenantRealm>
          <RestrictedTenantRealm
            requiredPermissions={[TenantPermission.ReadWorkspaces]}
            silent={true}
          >
            <Grid item>
              <WorkspacesCard />
            </Grid>
          </RestrictedTenantRealm>
        </RestrictedMakerRealm>
        <RestrictedTenantRealm
          requiredPermissions={[TenantPermission.ChangeTenantMemberPermissions]}
          silent={true}
        >
          <Grid item>
            <AdminConsoleCard />
          </Grid>
        </RestrictedTenantRealm>
      </Grid>
    </Grid>
  );
}
